module.exports = __webpack_public_path__ + "img/arrow-right-inverted.f87b3993.svg";